import React from "react";
import { BCMSDate, useBCMSContext, useStateManager, BCMSRecord } from "bcms-react";
import Classes, { CompanyAccount, Participant, PassThruHistory } from "model";
import "./styles.css";
import "./mobile.css";
import { PageContainer, PageContentView } from "components/shared";
import PendingACHPassThruWidget from "./components/PendingACHPassThruWidget";
import HistoryACHPassThruWidget from "./components/HistoryACHPassThruWidget";
import MobilePendingACHPassThruTable from "./components/MobilePendingACHPassThruTable";

/**
 * @function PassThruACHPage
 * @returns {React.Component}
 * @exported true
 * @description This is the main page for the PassThruACHPage.
 */
export default function PassThruACHPage(props) {
  const globalController = useBCMSContext();
  BCMSRecord.globalControllerFor(Classes, globalController);

  const data = { ...getDefaultData(), ...props.data ?? {} };
  const ui = { ...getDefaultUI(), ...props.ui ?? {} };

  const controller = (state, setState) => ({
      data: state.data,
      ui: state.ui,
  });

  return(
    <PageContainer className="pass-thru-ach-page" state={ { data, ui } } controller={ controller }>
      <PageContent/>
    </PageContainer>
  );
}

export const getDefaultData = () => ({
  historyACHPassThruWidgetData: {
    history: PassThruHistory.initAll()
  },
  pendingACHPassThruWidgetData: {
    pending: [],
    overridePastEffectiveDates: false,
    processAsThirdParty: false,
    skipDuplicateCheck: false,
    selectedDate: BCMSDate.init().nextBusinessDay(),
    skipInvalidEffectiveDates: false,
    showFileUploadedBanner: false,

    showFileUploadedTextArea: false,
    showFormattedContent: true,
    passThruACHDetailsModalIsOpen: false
  }
});

// no ui changes for now.
export const getDefaultUI = () => ({
  historyACHPassThruWidgetUI: {

  },
  pendingACHPassThruWidgetUI: {
    
  }
});

function PageContent(props) {
  const { data, ui } = useStateManager();

  return (
    <PageContentView>
      <div className="multi-widget-container flex-container flex-vertical">
        <PendingACHPassThruWidget data={ data.pendingACHPassThruWidgetData } ui={ ui.pendingACHPassThruWidgetUI } />
        <HistoryACHPassThruWidget data={ data.historyACHPassThruWidgetData } ui={ ui.historyACHPassThruWidgetUI } />
      </div>
    </PageContentView>
  );
}